<div class="popupWrapp">
  <h3>
    <mat-icon (click)="backClick()">arrow_back</mat-icon>
    Category
  </h3>
  <div class="popupCard">
    <div class="searchHeader">
      <form [formGroup]="searchForm">
        <div class="searchWrapp">
          <mat-icon>search</mat-icon>
          <input
            id="modules_rfq_popupdropdown_1"
            type="search"
            formControlName="searchText"
            placeholder="Search Category"
          />
        </div>
      </form>
    </div>
    <div class="popupBody checkboxItem">
      <div class="col-lg-6">
        <ul>
          <li *ngFor="let item of filteredData">

            <mat-checkbox
            (click)="getSubcategories(item.id)"
            [checked]="item.isChecked"
            [(ngModel)]="item.isChecked"
            (change)="onCheckboxChange(item)"
          ></mat-checkbox>
          <span (click)="getSubcategories(item.id)">{{ item.name }}</span>
        
          </li>
        </ul>
      </div>
      <div class="col-lg-6">
        <ul>
          <ng-container *ngFor="let item of subCategoriesList">
            <li >
              <mat-checkbox
                [checked]="item.isChecked"
                [(ngModel)]="item.isChecked"
                (change)="selectParentFromChild(item)"
              ></mat-checkbox>
              {{ item.name }}
            </li>
            <div *ngIf="item.name == 'Others' &&  isOtherSubCategoryInputVisible">
              <label>Sub Category Details<sup>*</sup></label>
              <mat-form-field appearance="outline">
                <input
                  id=""
                  matInput
                  placeholder="Sub Category Details"
                  [(ngModel)]="otherSubCategoryValue"
                  (input)="handleSaveBtn()"
                />
              </mat-form-field>
            </div>
          </ng-container>
        </ul>

        
      </div>
      <!-- <div class="optionWarpp">
                <ul class="dropList scroller">
                    <li class="checkboxItem" *ngFor="let category of filterItems();  let i = index">
                        <mat-checkbox [checked]="category.isChecked" [(ngModel)]="category.isChecked" (click)="clickCategory(i)">
                            {{category.categoryName}}
                        </mat-checkbox>
                    </li>
                </ul>
            </div>
            <div class="subWarpp">
                <ul class="dropList scroller">
                    <li class="checkboxItem" *ngFor="let subCategory of filterItems()[clickedCategory]?.subcategories">
                        <mat-checkbox [checked]="subCategory.isChecked" [(ngModel)]="subCategory.isChecked">
                            {{subCategory.subCategoryName}}
                        </mat-checkbox>
                    </li>
                </ul>
            </div> -->
    </div>
  </div>
  <div class="popupButton">
    <button
      id="modules_rfq_popupdropdown_2"
      mat-button
      color="primary"
      type="button"
      class="btnCustom btn-outline"
      (click)="unCheckAll()"
    >
      Clear
    </button>
    <button
      id="modules_rfq_popupdropdown_3"
      mat-button
      color="primary"
      type="button"
      class="btnCustom btn-primary"
      (click)="getSelectedCategories()"
      [disabled]="!isSaveBtnActive"
    >
      Save
    </button>
  </div>
</div>
